module.exports = __webpack_public_path__ + "static/media/close-button.acb6b7f5.png";